import { Link } from 'react-router-dom';
import styled from 'styled-components';
export const StepProgressContainer = styled.div`
  width: 100%;
`;
export const StyledNextRoomName = styled.p`
  margin-bottom: 1rem;
  text-align: left;
  font-weight: ${({
  theme
}) => theme.fonts.weight.bold};
  color: ${({
  theme
}) => theme.colors.text.main};
`;
export const StyledStepsWrapper = styled.div<{
  $isDarkMode?: boolean;
}>`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 3.5rem;
    top: 0;
    bottom: 0;
    width: 1px;
    border-left: 2px dashed
      ${({
  theme,
  $isDarkMode
}) => $isDarkMode ? 'rgba(62, 71, 90, 1)' : theme.colors.grey[300]};
  }
`;
export const StyledStep = styled(Link)<{
  $isCompleted?: boolean;
}>`
  position: relative;
  width: 100%;
  display: flex;
  margin-bottom: 2.4rem;
  padding-left: 2.4rem;
  align-items: center;
  text-decoration: none;
  color: unset;
  pointer-events: ${({
  $isCompleted
}) => $isCompleted ? 'none' : 'auto'};
  box-shadow: ${({
  theme,
  $isCompleted
}) => $isCompleted ? 'none' : `0 0 0 1px ${theme.colors.info.main}`};
  border-radius: 0.5rem;
`;
export const StyledStepIndicator = styled.div<{
  $isCompleted?: boolean;
  $isDarkMode?: boolean;
}>`
  margin-right: 4rem;
  z-index: 1;

  svg {
    color: ${({
  theme,
  $isCompleted,
  $isDarkMode
}) => {
  if ($isCompleted) {
    return $isDarkMode ? theme.colors.black : theme.colors.background.main;
  }
  return $isDarkMode ? theme.colors.background.dark : theme.colors.text.main;
}};
    background-color: ${({
  theme,
  $isCompleted,
  $isDarkMode
}) => {
  if ($isCompleted) {
    return $isDarkMode ? theme.colors.grey[300] : 'rgba(38, 137, 12, 1)';
  }
  return $isDarkMode ? theme.colors.border.dark : theme.colors.border.light;
}};
    height: 2.4rem;
    width: 2.4rem;
    border-radius: 50%;

    path {
      transform: scale(0.6);
      transform-origin: center;
    }
  }
`;
export const StyledStepContent = styled.div<{
  $isCompleted: boolean;
  $isDarkMode?: boolean;
}>`
  display: flex;
  align-items: center;
  padding: 1rem;
  border-radius: 0.5rem;
  box-shadow: ${({
  theme
}) => theme.boxShadow.light};
  flex-grow: 1;
  background-color: ${({
  $isCompleted,
  theme,
  $isDarkMode
}) => {
  if ($isCompleted) {
    return $isDarkMode ? theme.colors.statusTag.complete : theme.colors.alertBanner.success;
  }
  return $isDarkMode ? theme.colors.secondary.light : theme.colors.background.secondary;
}};

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.lg}) {
    padding: 1.6rem;

    p {
      line-height: 2rem;
    }
  }
`;
export const StyledStepImgWrapper = styled.div`
  width: 4.6rem;
  height: 4.6rem;
`;
export const StyledRoomImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const StyledRoomTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin-left: 1.6rem;

  > div {
    text-align: left;
  }

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.lg}) {
    width: 100%;
    flex-direction: row;
    align-items: flex-start;
  }
`;
export const StyledStepTitle = styled.p`
  color: ${({
  theme
}) => theme.colors.text.main};
  font-size: ${({
  theme
}) => theme.fonts.sizes.medium};
  font-weight: ${({
  theme
}) => theme.fonts.weight.bold};
  margin-bottom: 0.8rem;
`;
export const StyledStepDescription = styled.p<{
  $isDarkMode?: boolean;
}>`
  display: none;
  margin: 0;
  color: ${({
  theme,
  $isDarkMode
}) => $isDarkMode ? theme.colors.text.light : theme.colors.text.lighter};

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.lg}) {
    display: block;
  }
`;
export const StyledNextRoomToolTip = styled.p`
  position: absolute;
  left: 50%;
  top: -3rem;
  background-color: rgba(17, 83, 228, 1);
  color: ${({
  theme
}) => theme.colors.white};
  font-weight: ${({
  theme
}) => theme.fonts.weight.bold};
  padding: 1rem 1.2rem;
  border-radius: 0.5rem;
  transform: translateX(-50%);

  &::after {
    content: '';
    position: absolute;
    bottom: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
    border-top: 0.5rem solid;
    border-top-color: rgba(17, 83, 228, 1);
  }
`;